<div class="flex flex-col">
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Title</mat-label>
      <input matInput placeholder="Title" [(ngModel)]="data.input.title"
             particleAnalytics
             analyticsCategory="add-survey-dialog"
             analyticsAction="Report-title" required>
    </mat-form-field>
  </div>
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-1-100">
      <mat-label>Description</mat-label>
      <textarea matInput type="text" [(ngModel)]="data.input.description" required
                placeholder="Description" rows="5">
              </textarea>
    </mat-form-field>
  </div>
</div>


